import { initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import {
  connectAuthEmulator,
  initializeAuth,
  browserLocalPersistence,
  browserSessionPersistence,
  indexedDBLocalPersistence,
  inMemoryPersistence
} from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getPerformance } from 'firebase/performance';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true';

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// getAuth() eagerly wires up the default browserPopupRedirectResolver, which
// fetches the ~95KB OAuth helper iframe (`<authDomain>/__/auth/iframe.js`) on
// every page load to check for a pending redirect result - even for visitors
// who never sign in. That was the longest network dependency chain on the
// public homepage and a major contributor to LCP. initializeAuth() with
// popupRedirectResolver left unset skips that eager fetch; AdminPage passes
// browserPopupRedirectResolver explicitly to signInWithPopup instead.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence, inMemoryPersistence]
});
export const functions = getFunctions(app, 'us-central1');
export const perf = typeof window !== 'undefined' ? getPerformance(app) : null;
export const storage = getStorage(app);
if (useEmulator) {
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
